export function hasRichContent(html) {
  if (!html || typeof html !== 'string') return false;

  const textOnly = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;/gi, ' ')
    .trim();

  if (textOnly.length > 0) return true;

  return /<(img|video|iframe|embed|object|svg|figure)\b/i.test(html);
}
